"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TronOfflineConnector = void 0;
const BaseConnector_1 = require("../../../../Connectors/BaseConnector");
const TronAdapter_1 = require("../../Adapters/TronAdapter");
const MulticallBaseAdapter_1 = require("../../../../Adapters/Multicall/MulticallBaseAdapter");
const tronweb_1 = __importDefault(require("tronweb"));
class TronOfflineConnector extends BaseConnector_1.BaseConnector {
    constructor(config, metadata, params) {
        super(metadata, config);
        this.params = params;
    }
    async _connect() {
        const adapter = new TronAdapter_1.TronAdapter(this.config);
        const _a = this.params, { rateLimiter } = _a, params = __rest(_a, ["rateLimiter"]);
        const provider = new tronweb_1.default(params);
        provider.setAddress("TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t");
        adapter.setProvider(provider);
        if (rateLimiter) {
            rateLimiter.setLimiterOn(provider.fullNode.instance);
            rateLimiter.setLimiterOn(provider.eventServer.instance);
            rateLimiter.setLimiterOn(provider.solidityNode.instance);
        }
        const multicall = new MulticallBaseAdapter_1.MulticallBaseAdapter(adapter);
        return { adapter, multicall };
    }
}
exports.TronOfflineConnector = TronOfflineConnector;
